/**
 * @class Anzeige Allgemeiner Nachrichten (durch das MessageModul) und Logging in die Konsole
 */
class MessageHandler {
  /**
   *
   * @param {boolean} debug wenn true wird in die Konsole gelogged (Debug-Mode)
   * @param {boolean} logProps wenn true, werden auch immer die Props der Komponenten gelogged
   * @param {boolean} logStates  wenn true, werden auch immer die States der Komponenten gelogged
   * @param {boolean} showEmptyLogs  wenn true, werden auch leere Einträge geschrieben
   * @param {boolean} showRender  wenn true, werden auch render- Einträge gelogged
   */
  constructor(
    debug = false,
    logProps = false,
    logStates = false,
    showEmptyLogs = false,
    showRender = false,
  ) {
    this.debug = debug;
    this.logProps = logProps;
    this.logStates = logStates;
    this.showEmptyLogs = showEmptyLogs;
    this.showRender = showRender;
  }

  /**
   * Setzt das messageModul, welches z.b. Im PagesModul erst erstellt wird
   * @param {MessageModul} modul
   */
  setMessageModul(modul) {
    if (this.messageModul && this.messageModul.reset) {
      this.messageModul.reset();
    }
    this.messageModul = modul;
  }

  /**
   *
   * @param {string} type Typ der Nachricht: "error", "message", "success", "loading"
   * @param {string} message Nachricht (Zusammenfassung)
   * @param {string} detail Nachricht (Detail)
   */
  setMessage(type, message, detail) {
    if (this.messageModul && this.messageModul.setMessage) {
      this.messageModul.setMessage(type, message, detail);
    } else {
      this.logDebugFormatted(
        'MessageHandler',
        'setMessage',
        [this, type, message, detail],
        'MessageModul nicht gesetzt => Nachricht kann nicht angezeigt werden',
      );
    }
  }

  /**
   * Entfernen der Angezeigten Nachricht
   */
  reset() {
    this.messageModul.reset();
  }

  /**
   * Ausführliches Logging in die Konsole
   * @param {String} className Klasse, welche logged
   * @param {String} functionName Funktionsname, die logged
   * @param {object} parameter Parameter der Funktion
   * @param {object} props Props von Componenten
   * @param {object} state State von Componenten
   * @param {object} messages Nachricht oder Nachrichten
   */
  logDebugFormatted(
    className,
    functionName,
    parameter,
    props,
    state,
    messages,
  ) {
    if (this.debug) {
      if (functionName === 'render' && !this.showRender) return;
      console.group(`${className}; ${functionName};  `);
      this.logDebug(messages);
      console.groupEnd();
    }
  }

  /**
   * Kurzes Logging in die Konsole
   * @param {* } messages
   */
  logDebug(messages) {
    if (this.debug && (messages != '' || this.showEmptyLogs)) {
      if (Array.isArray(messages) && messages.length >= 0)
        messages.forEach(m => {
          if ((m && m != '') || this.showEmptyLogs) console.log(m);
        });
      else if ((messages && messages != '') || this.showEmptyLogs)
        console.log(messages);
    }
  }
}
export default MessageHandler;
